import React from 'react';
import { useHistory } from 'react-router-dom';
import { useAppDispatch } from '../../hooks/redux';
import { authSlice } from '../../store/reducers/AuthSlice';
import { GlobalRouteNames } from '../../models/Common';
import { PasswordRecoveryByEmail } from '../../components/loginParts/passwordRecoveryForms/RecoveryByEmail';

const RecoveryByEmailPage = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const { setFormError, setStep } = authSlice.actions;

  const handleComplete = () => {
    dispatch(setStep(0));
    history.push(GlobalRouteNames.LoginPage);
  };

  const handleBack = () => {
    dispatch(setFormError(null));
    history.goBack();
  };

  return (
    <div className="login-page page">
      <div className="login-page__container container">
        <PasswordRecoveryByEmail handleBack={handleBack} handleComplete={handleComplete} />
      </div>
    </div>
  );
};

export default RecoveryByEmailPage;
